// components
import { ForSigningComponent } from './for-signing.component';
import { ForSigningListComponent } from './list/forsigning.list.component';
import { ForSigningSingleIndexComponent } from './single-index/forsigning.single.index.component';
import { ForSigningObjectsComponent } from './objects/forsigning.objects.component';
import { DeclineComponent } from './decline/decline.dialog.component';
import { DeclineDialogContractStateService } from './decline/decline.dialog.state.service';

export const FORSIGNING_COMPONENTS: any[] = [
  ForSigningComponent,
  ForSigningListComponent,
  ForSigningSingleIndexComponent,
  ForSigningObjectsComponent,
  DeclineComponent,
];

// services
import { ForSigningModelService } from './for-signing.model.service';


export const FORSIGNING_SERVICES: any[] = [
  ForSigningModelService,
  DeclineDialogContractStateService,
];



// WEBPACK FOOTER //
// ./src/app/components/dashboard/for-signing/index.ts